import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../../hooks/useAuth';
import styles from './Sidebar.module.scss';

// MenuIcon component with SVG icons
const MenuIcon: React.FC<{ iconName: string; size?: number; className?: string }> = ({ 
  iconName, 
  size = 20, 
  className = "" 
}) => {
  const getIcon = (name: string) => {
    switch (name) {
      case 'dashboard':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path d="M3 3v8h8V3H3zM13 3v8h8V3h-8zM3 13v8h8v-8H3zM13 13v8h8v-8h-8z" 
                  stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        );
        
      case 'customers':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" 
                  stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87" 
                  stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M16 3.13a4 4 0 0 1 0 7.75" 
                  stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        );
        
      case 'invoices':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" 
                  stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M14 2v6h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        );
        
      case 'employees':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" 
                  stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 2v3" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <path d="M9 3h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        );
        
      case 'received-amount':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 6v6l4 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M16 16h-8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <path d="M12 16V8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        );
        
      case 'documents':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" 
                  stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        );
        
      case 'settings':
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" 
                  stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        );

        case 'document-storage':
          return (
            <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
              <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" 
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 14v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              <path d="M14 16l-2-2-2 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          );

          case 'reports':
            return (
              <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
                <path d="M3 3v18h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M18 17l-3-3-4 4-4-4-4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <circle cx="7" cy="14" r="1" fill="currentColor"/>
                <circle cx="11" cy="10" r="1" fill="currentColor"/>
                <circle cx="15" cy="14" r="1" fill="currentColor"/>
                <circle cx="18" cy="8" r="1" fill="currentColor"/>
              </svg>
            );

            case 'instructions':
              return (
                <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M14 2v6h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  <path d="M12 9l2 2-2 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              );

            case 'account-head':
              return (
                <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
                  <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M5.5 21v-2a4 4 0 0 1 4-4h5a4 4 0 0 1 4 4v2" 
                        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M16 11h5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  <path d="M21 11v6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  <path d="M18.5 14h5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  <circle cx="4" cy="4" r="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M4 8v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              );

              case 'data-sheet':
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" 
            stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M3 9h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <path d="M9 3v18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <path d="M15 3v18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <path d="M3 15h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <circle cx="6" cy="6" r="1" fill="currentColor"/>
      <circle cx="12" cy="6" r="1" fill="currentColor"/>
      <circle cx="18" cy="6" r="1" fill="currentColor"/>
    </svg>
  );
        
      default:
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M8 12h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <path d="M12 8v8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        );
    }
  };

  return getIcon(iconName);
};

// Updated menu items with icon names instead of emojis
let menuItems = [
  { label: 'Dashboard', path: '/dashboard', icon: 'dashboard' },
  { label: 'Employees', path: '/employees', icon: 'employees', permission: 'canManageEmployees' },
  { label: 'Customers', path: '/customers', icon: 'customers', permission: 'canManageCustomers' },
  { label: 'Invoices', path: '/invoices', icon: 'invoices' },
  { label: 'Account Head', path: '/account-head', icon: 'account-head', permission: 'canManageSettings' },
  { label: 'Received Amount', path: '/received-amount', icon: 'received-amount' },
  { label: 'Report', path: '/reports', icon: 'reports' },
  { label: 'Data Sheets', path: '/data-sheets', icon: 'data-sheet' },
  { label: 'Instructions', path: '/instructions', icon: 'instructions', permission: 'canManageSettings' },
  { label: 'Settings', path: '/settings', icon: 'settings', permission: 'canManageSettings' },
  { label: 'Documents', path: '/documents', icon: 'documents' },
  { label: 'CC Storage', path: '/document-storage', icon: 'document-storage' },
];

interface SidebarProps {
  role?: string;
  permissions?: any;
  onClose?: () => void;
  isMobile?: boolean;
}

const Sidebar: React.FC<SidebarProps> = ({ 
  role = 'employee', 
  permissions = {}, 
  onClose,
  isMobile = false 
}) => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(true);
  const { auth } = useAuth();
  const isCloudActive = auth.user?.is_cloud_active === true;

  // Check if company is inactive
  const isCompanyInactive = auth.user?.company_is_active === false;
  
  // Check if storage is disabled
  const isStorageDisabled = auth.user?.storage_enabled === false;

  // Admin users get all permissions automatically
  const effectivePermissions = role === 'admin' 
    ? {
        ...permissions,
        canManageCustomers: true,
        canManageInvoices: true,
        canManageEmployees: true,
        canViewReports: true,
        canCreateEmployee: true,
        canEditEmployee: true,
        canManageSettings: true,
        canManageDocuments: true,
        canManageDataSheets: true
      }
    : {
      
      ... permissions,
      canManageDocuments: true,
    }

  

  const handleNavClick = () => {
    // Close sidebar on mobile when navigation item is clicked
    if (isMobile && onClose) {
      onClose();
    }
  };

  if (auth.user?.is_cloud_active) {
    menuItems = [
      { label: 'Employees', path: '/employees', icon: 'employees', permission: 'canManageEmployees' },
      { label: 'Cloud Storage', path: '/cloud-storage', icon: 'cloud-storage' },
      { label: 'Settings', path: '/settings', icon: 'settings', permission: 'canManageSettings' },
    ];
  }

  // Filter menu items based on company status and storage settings
  const filteredMenuItems = isCompanyInactive 
    ? menuItems.filter(item => item.path === '/reports') // Only show reports for inactive companies
    : menuItems.filter(item => {
        // Hide Documents and CC Storage when storage is disabled
        if (isStorageDisabled && (item.path === '/documents' || item.path === '/document-storage')) {
          return false;
        }
        return true;
      });

  return (
    <aside className={collapsed ? `${styles.sidebar} ${styles.collapsed}` : styles.sidebar}>
      <div className={styles.logoArea}>
       
      </div>
      {/* Collapse/Expand toggle button */}
      <button
        className={styles.collapseToggle}
        onClick={() => setCollapsed((c) => !c)}
        aria-label={collapsed ? 'Expand menu' : 'Collapse menu'}
      >
        {collapsed ? (
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg>
        ) : (
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6"/></svg>
        )}
      </button>
      {/* Mobile close button */}
      {isMobile && onClose && (
        <button 
          className={styles.closeButton}
          onClick={onClose}
          aria-label="Close menu"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      )}
      
      <nav>
        <ul>
          {filteredMenuItems
            .filter(item => {
              // Always show Dashboard and Received Amount
              if (!item.permission) return true;
              
              // Check if user has the required permission
              return effectivePermissions[item.permission] === true;
            })
            .map(item => {
              const isActive = location.pathname === item.path || 
                              (item.path !== '/dashboard' && location.pathname.startsWith(item.path));
              
              return (
                <li key={item.path}>
                  <Link 
                    to={item.path} 
                    className={`${styles.navLink} ${isActive ? styles.active : ''} ${collapsed ? styles.collapsedLink : ''}`}
                    onClick={handleNavClick}
                    data-label={item.label}
                  >
                    <span className={styles.icon}>
                      <MenuIcon iconName={item.icon} size={20} />
                    </span>
                    {!collapsed && item.label}
                  </Link>
                </li>
              );
            })}
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;
